export default __webpack_public_path__ + "static/media/lock-screen.d58d3a07.png";